// extracted by mini-css-extract-plugin
export default {"List":"List_List__H21w0","horizontal":"List_horizontal__3jf-a"};